<template>
  <div class="section">
    <div v-if="header" class="header side-gap">
      <h1>{{header}}</h1>
    </div>
    <div ref="bg" class="side-gap" :class="background ? 'background' : undefined">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Section',
  components: {
  },
  props: {
    header: String,
    background: String,
  },
  watch: {
    background() {
      this.update();
    },
  },
  mounted() {
    this.update();
  },
  methods: {
    update() {
      if (!this.$refs.bg) return;
      if (this.background) {
        this.$refs.bg.style.backgroundImage = `url("/img/${this.background}")`;
      } else {
        this.$refs.bg.style.background = 'none';
      }
    }
  }
}
</script>

<style scoped lang="scss">

.section {
  margin-top: 20px;
  margin-bottom: 20px;

  .header {
    margin-top: 40px;
    margin-bottom: 40px;
    h1 {
      padding: 0;
      margin: 0;
    }
  }

  .background {
    //background: black;
    //background-image: url("/img/order.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: right;
  }
}

</style>
